module.exports = "<div id=\"health-status\">OK</div>\n"